import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to include modified fields in modify payload for Command experience
 */
@Injectable()
export class ModifiedFieldsCommandFeature implements IFlagFeature {
  name = Features.MODIFIED_FIELDS_COMMAND;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
